import { render, staticRenderFns } from "./FooterForm.vue?vue&type=template&id=161108f9&scoped=true&"
import script from "./FooterForm.vue?vue&type=script&lang=js&"
export * from "./FooterForm.vue?vue&type=script&lang=js&"
import style0 from "./FooterForm.vue?vue&type=style&index=0&id=161108f9&prod&scoped=true&lang=sass&"
import style1 from "./FooterForm.vue?vue&type=style&index=1&id=161108f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161108f9",
  null
  
)

export default component.exports